import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle, ArrowUpRight } from "lucide-react";import { COMPANY } from "@/data/content";

const colCompany = [
  { label: "About Us", to: "/about" },
  { label: "Industries & Products", to: "/industries" },
  { label: "Solutions", to: "/solutions" },
  { label: "Contact Us", to: "/contact" },
];

const colSolutions = ["Sourcing", "Logistics", "Inspection", "Warehousing", "Sampling", "Trade Support"];

const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[color:var(--brand-blue)] opacity-20 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[color:var(--brand-red)] opacity-10 blur-3xl" />

      <div className="container-x relative z-10 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="inline-flex rounded-xl bg-white px-4 py-3">
              <img src={COMPANY.logo} alt="SPMS Global" className="h-10 w-auto object-contain" />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Your trusted partner in global sourcing, supply and trade — from product sourcing and
              inspection to logistics, warehousing and delivery.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Company</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {colCompany.map((c) => (
                <li key={c.to}>
                  <Link to={c.to} className="text-slate-400 transition-colors duration-200 hover:text-white" data-testid={`footer-link-${c.to.slice(1)}`}>
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Solutions</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {colSolutions.map((s) => (
                <li key={s}>
                  <Link to="/solutions" className="text-slate-400 transition-colors duration-200 hover:text-white">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--brand-red)]" />
                <span className="text-slate-400">{COMPANY.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-[color:var(--brand-red)]" />
                <a href={`mailto:${COMPANY.emailRaw}`} className="break-all text-slate-400 hover:text-white" data-testid="footer-email">{COMPANY.email}</a>
              </li>
            </ul>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-1.5 rounded-full border border-white/20 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-white hover:text-slate-950">
              Send an Enquiry <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-sm text-slate-500 md:flex-row">
          <p>© 2026 {COMPANY.legalName}. All Rights Reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
